import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
interface SliderQuestionProps {
  title: string;
  value: number;
  onChange: (val: number) => void;
  onContinue: () => void;
  note?: string;
}
export function SliderQuestion({
  title,
  value,
  onChange,
  onContinue,
  note
}: SliderQuestionProps) {
  const getColorClass = () => {
    if (value <= 3) return 'text-brand-green';
    if (value <= 7) return 'text-orange-400';
    return 'text-red-500';
  };
  // This is always a long question
  return <div className="flex flex-col h-full flex-1" data-id="element-301">
      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-5" data-id="element-302">
        <h2 className="text-quiz-h2-long md:text-quiz-h2-long-desktop font-heading font-semibold text-brand-dark mb-3 text-center" data-id="element-303">
          {title}
        </h2>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.97
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.1,
      duration: 0.35
    }} className="flex-1 flex flex-col justify-center mb-5" data-id="element-304">
        <div className="bg-gray-50 p-6 rounded-[1.5rem] border border-gray-100 shadow-sm" data-id="element-305">
          <div className="text-center mb-6" data-id="element-306">
            <motion.span key={value} initial={{
            scale: 0.8,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} className={`text-result-score font-heading font-bold ${getColorClass()} transition-colors duration-300`} data-id="element-307">
              {value}
            </motion.span>
          </div>

          <input type="range" min="1" max="10" value={value} onChange={e => onChange(parseInt(e.target.value))} className="w-full mb-5" data-id="element-308" />

          <div className="flex justify-between text-disclaimer font-medium text-gray-500" data-id="element-309">
            <span className="w-28 text-left leading-tight" data-id="element-310">
              1 = Mayormente tranquilo
            </span>
            <span className="w-32 text-right leading-tight" data-id="element-311">
              10 = Siento que todo se sale de control
            </span>
          </div>
        </div>
      </motion.div>

      {note && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.3
    }} className="bg-brand-beige/40 p-4 rounded-2xl mb-4 border border-brand-beige/60" data-id="element-312">
          <p className="text-helper text-gray-700 leading-relaxed" data-id="element-313">{note}</p>
        </motion.div>}

      <div className="mt-auto pt-3 pb-safe" data-id="element-314">
        <Button onClick={onContinue} data-id="element-315">Continuar</Button>
      </div>
    </div>;
}